import { api } from '../../lib/api-client';

export type TalentListItem = {
  /**
   * `Candidate.PublicKey` (Guid). El backend nunca expone la PK secuencial al cliente
   * — esto es anti-enumeration por diseño (SW-404). Usar SIEMPRE como external ID.
   */
  id: string;
  fullName: string;
  currentCompany: string | null;
  seniority: string | null;
  country: string | null;
  city: string | null;
  profilePhotoId: string | null;
  topSkills: string[];
  /**
   * SW-145: action del user actual sobre este talent. El backend lo incluye en el list
   * response para eliminar el N+1 (antes el FE hacía GET /actions per card). Valores:
   *  - 'Interested' / 'NotInterested' (PascalCase, enum del BE)
   *  - null cuando el user no actuó todavía
   */
  myAction: 'Interested' | 'NotInterested' | null;
};

export type TalentsResponse = {
  items: TalentListItem[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
};

export type GetShortlistTalentsParams = {
  /**
   * `Project.PublicKey` Guid string — el path param del endpoint
   * `GET /api/client/shortlists/{publicKey:guid}/talents`. Ver SW-407 / ADR-007.
   */
  shortlistPublicKey: string;
  pageNumber?: number;
  pageSize?: number;
};

export async function getShortlistTalents(
  params: GetShortlistTalentsParams,
): Promise<TalentsResponse> {
  const search = new URLSearchParams();
  if (params.pageNumber !== undefined) search.set('pageNumber', String(params.pageNumber));
  if (params.pageSize !== undefined) search.set('pageSize', String(params.pageSize));
  const query = search.toString();
  const url = query
    ? `/api/client/shortlists/${params.shortlistPublicKey}/talents?${query}`
    : `/api/client/shortlists/${params.shortlistPublicKey}/talents`;
  return api.get<TalentsResponse>(url);
}
